import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setOvertimeAllowed, setPayRateType, setShowCalenderModal, setjobMultishiftOccurreneUpdateList, updateEditDayDate, updateJobInfo, updateSingleShiftEndDate } from "./slice";
import { payRateTypeObj, shiftTypeObj } from "../../helpers/data";
import { formatNumberWithCommas, formatNumberWithoutCommas, handleDecimalValueOnOnChange } from "../../helpers/regEx";
import DropDown from "../common/SearchableSelect";
import { recurrenceStructring, totalShiftAmountCalculation, updateRecusionFlag, updateShift } from "./action";
import DateField from '../common/TextField/dateTime';
import { getSingleShiftEndDate } from "./transformer";

const PayRate = (props) => {
  const dispatch = useDispatch();
  const payRateType = useSelector((store) => store.jobOpportunity.payRateType);
  const selectedOption = useSelector((store) => store.jobOpportunity.selectedOption);
  const payRateTotalShiftAmount = useSelector((store) => store.jobOpportunity.payRateTotalShiftAmount);
  const payRateOccurrenceAmount = useSelector((store) => store.jobOpportunity.payRateOccurrenceAmount);
  const recursionFlag = useSelector((store) => store.jobOpportunity.recursionFlag);
  const shift = useSelector((store) => store.jobOpportunity.shift);
  const allPreferedShifts = useSelector((store) => store.jobOpportunity.masterData?.allPreferedShifts);
  const payRateChangeHandler = (e) => {
    const { name, value } = e.target;
    dispatch(
      setPayRateType({ name: "payRateType", value: payRateTypeObj[name] })
    );
    dispatch(setShowCalenderModal(false))
    dispatch(setjobMultishiftOccurreneUpdateList([]));
    // console.log({value:payRateTypeObj[name]});
    if(payRateTypeObj?.manualCal === +payRateTypeObj[name]){
      dispatch(setOvertimeAllowed(true));
      // dispatch(updateJobInfo({field:"incentive",data:""}))
    }
    if(payRateTypeObj?.systemCal === +payRateTypeObj[name]){
      dispatch(setOvertimeAllowed(false));
      dispatch(setPayRateType({ name:"payRateTotalShiftAmount", value: null }));
      dispatch(setPayRateType({ name:"payRateOccurrenceAmount", value: null }));
    }
  };
  const payRateShiftAmountHandler = (e) => {
    const { name, value } = e.target;
    dispatch(
      setPayRateType({ name, value: handleDecimalValueOnOnChange(value) })
    );
    dispatch(setShowCalenderModal(false))
    dispatch(setjobMultishiftOccurreneUpdateList([]));
  };
  const payRateTotalShiftAmountHandler = (e) => {
    const { name, value } = e.target;
    const removeExistComma = formatNumberWithoutCommas(value);
    const decimalConversion = handleDecimalValueOnOnChange(removeExistComma);
    // const formattedValue = formatNumberWithCommas(decimalConversion);
    dispatch(setPayRateType({ name, value: decimalConversion}));
    dispatch(setShowCalenderModal(false))
    dispatch(setjobMultishiftOccurreneUpdateList([]));
    if(+recursionFlag === shiftTypeObj.multiShift){
      dispatch(totalShiftAmountCalculation())
    }
  }
  const listValue = [
    { id: 1, name: "Single Shift" },
    { id: 3, name: "MultiShift" },
    { id: 2, name: "Daily Encounters" },
  ];
  const updareRecurrsionHandler = (target) => {
    if (target?.value?.id !== "") {
      dispatch(updateRecusionFlag(target?.value?.id));
    }
    // console.log(target?.value?.id);
    if (+target?.value?.id === 2) {
      dispatch(
        setPayRateType({
          name: "payRateType",
          value: payRateTypeObj?.systemCal,
        })
      );
    }
    if(+target?.value?.id === shiftTypeObj.singleShift){
      const singleShiftEndDate = getSingleShiftEndDate(shift?.date,shift?.startTime?.id,shift?.preferedShift?.id);
      dispatch(updateSingleShiftEndDate(singleShiftEndDate))
    }
    if(+target?.value?.id === shiftTypeObj.multiShift){
      // maxhour for multshift
      const maxMultiShiftHours = 24 * 60 ;
      if(+shift?.preferedShift?.id ){
        if(+shift?.preferedShift?.id > maxMultiShiftHours){
          const res = allPreferedShifts?.find(length => + length?.id === maxMultiShiftHours)
          dispatch(updateShift("preferedShift", res))
        }
      }
    }
    if(+target?.value?.id === shiftTypeObj.multiShift){
      dispatch(totalShiftAmountCalculation())
    }
  };
  const updateEndShiftDetails = (target) => {
    const value = target.value;
    dispatch(setShowCalenderModal(false))
    // dispatch(setjobMultishiftOccurreneUpdateList([]));
    dispatch(updateEditDayDate([]))
    if (target.action === 'remove') {
      dispatch(updateShift(target.name, ''));
    } else {
      dispatch(updateShift(target.name, value)).then(() => {
        dispatch(recurrenceStructring());
      });
    }
  };
  
  const updateShiftDetails = (target) => {
    dispatch(setShowCalenderModal(false))
    // dispatch(setjobMultishiftOccurreneUpdateList([]));
    // dispatch(setJobShiftAmountMultishiftOccurreneUpdateList([]));
    dispatch(updateEditDayDate([]))
    const value = target.value;
    const name = target?.name;
    if (name === "endTime") {
      dispatch(setjobMultishiftOccurreneUpdateList([]));
    }
    if (target.action === 'remove') {
      dispatch(updateShift(target.name, ''));
    } else {
      console.log({target,value,name});
      dispatch(updateShift(target.name, value)).then(() => {
        dispatch(recurrenceStructring());
      })
    }
  };
  return (
    <div className="card">
      <div>
        <div className="row">
          <div className="card-header">
            <div className="col-lg-4 col-md-4">
              <h3 class="card-title">
                Recurrence & Pay Rate <span class="required">*</span>
              </h3>
            </div>
          </div>
          <div className="card-body">
            <div className="row ">
              <DropDown
                isDisabled={selectedOption?.editJobPost}
                name={"recurrence"}
                // id={"jobCategory"}
                label="Recurrence"
                options={listValue}
                disabled={props.RecurrenceDisabled}
                value={[
                  recursionFlag
                    ? listValue.find(
                        (item) => item.id === parseInt(recursionFlag)
                      )
                    : [],
                ]}
                multiple={false}
                updateValue={updareRecurrsionHandler}
                isObject={true}
                divClass={"col-3"}
              />
                {props?.isEditMode &&
              parseInt(recursionFlag) === 3 &&
              +payRateType === payRateTypeObj.manualCal ? (
                <>
                  <DateField
                    name={"date"}
                    star="*"
                    divClass={`col-3`}
                    label={"Date"}
                    id={"date"}
                    value={shift?.date}
                    updateValue={updateShiftDetails}
                    includeTime={false}
                    errors={props.errors["shiftDate"]}
                    isMandatory={"yes"}
                  />
                  <DateField
                    name={"endDate"}
                    star="*"
                    divClass={`col-3`}
                    label={"End Date"}
                    id={"enddate"}
                    value={shift?.endDate}
                    updateValue={updateEndShiftDetails}
                    includeTime={false}
                    errors={props.errors["endDate"]}
                    isMandatory={"yes"}
                  />
                </>
              ) : (
                ""
              )}
            </div>
            <div className="row">
             <span> Pay Rate <span class="required">*</span></span>
            </div>
            <div className="row col-lg-12">
              <div className="payrate-grid-align">
                <div class="form-check py-4 m-0">
                  <input
                    className="form-check-input"
                    type="radio"
                    name={`systemCal`}
                    id={`systemCal`}
                    onChange={payRateChangeHandler}
                    checked={
                      payRateType === payRateTypeObj.systemCal ? true : false
                    }
                  />
                  <label
                    style={{ cursor: "pointer" }}
                    htmlFor={`systemCal`}
                    className="form-check-label"
                  >
                    System Payrate
                  </label>
                </div>
                <div class="form-check  py-4 m-0">
                  <input
                    className="form-check-input"
                    type="radio"
                    name={`manualCal`}
                    id={`manualCal`}
                    onChange={payRateChangeHandler}
                    checked={
                      payRateType === payRateTypeObj.manualCal ? true : false
                    }
                    disabled={+recursionFlag === 2}
                  />
                  <label
                    style={{ cursor: "pointer" }}
                    htmlFor={`manualCal`}
                    class="form-check-label"
                  >
                    Fixed Payrate
                  </label>
                </div>
                {+payRateType === +payRateTypeObj.manualCal ? (
                  <>
                  {
                    +recursionFlag !== shiftTypeObj.multiShift && (
                      <div className="form-check  py-4 m-0">
                      <label htmlFor="payRateTotalShiftAmount">
                        Total Shift Amount <span class="required">* </span>
                      </label>
                      <span
                        className={` form-control ${
                          payRateTotalShiftAmount && "showDollar_input"
                        }`}
                      >
                        <input
                          type="text"
                          placeholder="Enter Total Shift Amount"
                          className="showDollar_input_default "
                          name="payRateTotalShiftAmount"
                          id="payRateTotalShiftAmount"
                          value={
                            payRateTotalShiftAmount
                              ? formatNumberWithCommas(payRateTotalShiftAmount)
                              : ""
                          }
                          onChange={payRateTotalShiftAmountHandler}
                        />
                      </span>
                      {props?.errors?.payRateTotalShiftAmount?.length > 0 &&
                        props?.errors?.payRateTotalShiftAmount?.map((error) => (
                          <div className="invalid-input">{error}</div>
                        ))}
                    </div>
                    )
                  }
                    {+recursionFlag === shiftTypeObj.multiShift ? (
                      <div className="form-check  py-4 m-0">
                        <label htmlFor="eachOccurrenceShiftAmount">
                        Amount Per Shift{" "}
                          <span class="required">* </span>
                        </label>
                        <span
                          className={` form-control ${
                            payRateOccurrenceAmount && "showDollar_input"
                          }`}
                        >
                          <input
                            type="text"
                            placeholder="Enter Amount Per Shift"
                            className="showDollar_input_default"
                            name="payRateOccurrenceAmount"
                            id="payRateOccurrenceAmount"
                            value={
                              payRateOccurrenceAmount
                                ? formatNumberWithCommas(payRateOccurrenceAmount)
                                : ""
                            }
                            onChange={payRateTotalShiftAmountHandler}
                          />
                        </span>

                        {props?.errors?.payRateOccurrenceAmount?.length > 0 &&
                          props?.errors?.payRateOccurrenceAmount?.map(
                            (error) => (
                              <div className="invalid-input">{error}</div>
                            )
                          )}
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  ""
                )}
              </div>
              {props?.errors?.payRateType?.length > 0 &&
                props?.errors?.payRateType?.map((error) => (
                  <div className="invalid-input">{error}</div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayRate;
